﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";

export function initColorSelector() {
    $(".color-selector").each(function () {
        const $this = $(this);
        const $input = $this.find("input");

        if ($input.val()) {
            $this.find('[data-value="' + $input.val() + '"]').addClass("checked");
        }

        $this.find('[data-value]').on("click", function () {
            let circleRadio=$(this);
            let value = circleRadio.data("value");
            $input.val(value);
            $this.find("[data-value].checked svg").remove();
            $this.find("[data-value].checked").removeClass("checked");
            circleRadio.addClass("checked");
            circleRadio.append('<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="'+ pickTextColorBasedOnBgColorAdvanced(circleRadio.data('color'),'#FFFFFF', '#000000') +'" class="bi bi-check" viewBox="0 0 16 16">\n' +
                '  <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>\n' +
                '</svg>');
        });
    });
}

function pickTextColorBasedOnBgColorAdvanced(bgColor, lightColor, darkColor) {
    let color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
    let r = parseInt(color.substring(0, 2), 16); // hexToR
    let g = parseInt(color.substring(2, 4), 16); // hexToG
    let b = parseInt(color.substring(4, 6), 16); // hexToB
    let uiColors = [r / 255, g / 255, b / 255];
    let c = uiColors.map((col) => {
        if (col <= 0.03928) {
            return col / 12.92;
        }
        return Math.pow((col + 0.055) / 1.055, 2.4);
    });
    let L = (0.2126 * c[0]) + (0.7152 * c[1]) + (0.0722 * c[2]);
    return (L > 0.179) ? darkColor : lightColor;
}